"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tripContactDeserialize = void 0;
const unwrap_1 = __importDefault(require("../util/unwrap"));
const deserializeBoolean_1 = __importDefault(require("./deserializeBoolean"));
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const UserType_1 = require("./UserType");
function tripContactDeserialize(value) {
    const object = (0, deserializeObject_1.default)(value);
    if (Object.keys(object).length === 0) {
        throw new Error('Trip contact is an empty object');
    }
    return {
        name: (0, unwrap_1.default)(object.name, deserializeString_1.deserializeString),
        phone: (0, unwrap_1.default)(object.phone, deserializeString_1.deserializeString),
        supportsSms: (0, unwrap_1.default)(object.supportsSms, deserializeBoolean_1.default),
        uid: (0, unwrap_1.default)(object.uid, deserializeString_1.deserializeString),
        userType: (0, unwrap_1.default)(object.userType, UserType_1.userTypeDeserialize),
    };
}
exports.tripContactDeserialize = tripContactDeserialize;
